module.exports = __webpack_public_path__ + "static/media/logo.29981b72.png";